// src/services/heroService.js
import { db } from "../firebaseConfig";
import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
  query,
  where,
  orderBy,
  getDocs,
} from "firebase/firestore";

const COLL = "heroSlides";

export async function addHeroSlide(data) {
  const payload = {
    type: data.type || "image", // 'image' | 'video'
    src: data.src || "",
    poster: data.poster || "",
    alt: data.alt || "",
    title: data.title || "",
    subtitle: data.subtitle || "",
    ctaText: data.ctaText || "",
    ctaHref: data.ctaHref || "",
    interval: Number(data.interval || 5000),
    active: data.active ?? true,
    order: Number.isFinite(Number(data.order)) ? Number(data.order) : Date.now(),
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };
  const ref = await addDoc(collection(db, COLL), payload);
  return ref.id;
}

export async function updateHeroSlide(id, patch) {
  await updateDoc(doc(db, COLL, id), { ...patch, updatedAt: serverTimestamp() });
}

export async function deleteHeroSlide(id) {
  await deleteDoc(doc(db, COLL, id));
}

export async function listHeroSlidesAdmin() {
  const snap = await getDocs(query(collection(db, COLL), orderBy("order", "asc")));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function listActiveHeroSlides() {
  // Tente avec tri serveur (rapide)…
  try {
    const q = query(
      collection(db, COLL),
      where("active", "==", true),
      orderBy("order", "asc")
    );
    const snap = await getDocs(q);
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  } catch (e) {
    // …sinon fallback sans orderBy (utile pendant la création d’index)
    console.warn("listActiveHeroSlides fallback (create index active+order):", e?.message);
    const snap = await getDocs(query(collection(db, COLL), where("active", "==", true)));
    return snap.docs
      .map((d) => ({ id: d.id, ...d.data() }))
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }
}
